'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var raf = require('@mx/util/raf');
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('span', [_vm._v(_vm._s(_vm.value))]);
  },
  staticRenderFns: [],
  name: 'count-up',
  props: {
    duration: {
      type: Number,
      required: true
    },
    startValue: {
      type: Number,
      default: 0
    },
    endValue: {
      type: Number,
      required: true
    },
    decimal: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      value: '',
      startTime: 0
    };
  },
  mounted: function mounted() {
    this.startTime = Date.now();
    this.count();
  },
  methods: {
    count: function count() {
      var now = Date.now();
      var startValue = this.startValue,
          endValue = this.endValue,
          duration = this.duration;
      var progress = now - this.startTime;
      var value = startValue + (endValue - startValue) * progress / duration;
      value = Math[startValue > endValue ? 'max' : 'min'](value, endValue);
      this.value = value.toFixed(this.decimal);

      if (progress < duration) {
        raf.raf(this.count);
      }
    }
  }
});

exports.default = index;
